/** @jsx jsx */
import { jsx } from '@emotion/core';
import { bool, string, oneOfType, number, node } from 'prop-types';
import * as React from 'react';
import Box from '../Box';
import css from '@styled-system/css';
import Divider from '../../Divider';

const Stack = ({ gap = 'gutter', children, dividers, ...rest }) => {
  return (
    <Box
      css={css({
        '> * + *': {
          marginTop: gap,
        },
      })}
      {...rest}
    >
      {React.Children.toArray(children)
        .filter(Boolean)
        .map((child, i) => (
          <React.Fragment key={i}>
            {dividers && i > 0 && <Divider />}
            {child}
          </React.Fragment>
        ))}
    </Box>
  );
};

Stack.propTypes = {
  children: node,
  gap: oneOfType([string, number]),
  dividers: bool,
};

export default Stack;
